module.exports = __webpack_public_path__ + "static/img/repast04.9b4b1894.jpg";